module.exports = __webpack_public_path__ + "img/warn.3ff63e6c.svg";